// extracted by mini-css-extract-plugin
export default {"container":"FAQs_container__6DJX7","contentContainer":"FAQs_contentContainer__1WKa1","heading":"FAQs_heading__CYh25"};